'use strict';

import { prepareVideos, playVideoPlayer } from '../../../api/media/video';
import ResourceCore from './resource-core.common';

export default {
    mixins: [
        ResourceCore,
    ],
    data() {
        return {
            provider: '',
        }
    },
    methods: {
        prepareVideo() {
            prepareVideos();
        },
        openResourceVideo() {
            if (!this.resourceIsOpened) {
                if (this.$refs.razorPlayer) {
                    this.prepareVideo();
                    playVideoPlayer(this.$refs.razorPlayer.querySelector('[data-video-player]'), {});
                } else if (this.$refs.videoPlayer) {
                    this.provider = this.$refs.videoPlayer.$el.dataset.provider || '';
                    this.$refs.videoPlayer.$el.click();
                }
            }
        }
    },
}